$(function() {
    setTimeout(function() {
        var customers_rating =  $('.customers-rating');
        customers_rating.slick({
            dots: true,
            arrow: true,
            focusOnSelect: true,
            infinite: false,
            speed: 500,
            slidesToShow: 5.7,
            slidesToScroll: 1,
            touchThreshold: 5,
            prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
            responsive: [
            {
                breakpoint: 1600,
                settings: {
                slidesToShow: 3.6,
                arrow:false,
                }
            },
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 2.5,
                arrow:false,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.2,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.3,
                    arrows: false,
                }
            },
        ]
        });
    }, 500);
});
